import api from './api';
import { StatusDefinition, StatusDomain } from '../types';

export const statusService = {
  getAll: async (domain: StatusDomain): Promise<StatusDefinition[]> => {
    const response = await api.get('/statuses', { params: { domain } });
    return response.data;
  },

  create: async (status: Omit<StatusDefinition, 'id'>): Promise<StatusDefinition> => {
    const response = await api.post('/statuses', status);
    return response.data;
  },

  update: async (id: number, status: Partial<StatusDefinition>): Promise<StatusDefinition> => {
    const response = await api.put(`/statuses/${id}`, status);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/statuses/${id}`);
  },
};
